import React, { useEffect, useRef } from 'react';
import {connect} from 'react-redux';
import {Map} from 'immutable';
import {defineMessages, FormattedMessage} from 'react-intl';
import Spinner from 'components/Spinner';
import ClosePOSelector from '../selectors/ClosePO';
import * as Notes from '../selectors/Notes';
import  * as actions from '../actions/ClosePO';
import  * as events from '../events/ClosePO';
import ClosePurchaseOrder from '../../ClosePO/components/ClosePO';
import Title from 'components/Title';
import PurchaseOrderBasicDetails from 'AddEditView/PurchaseOrderBasicDetails';
import ApprovedLineItems from '../../shared/components/ApprovedLineItems';
import POTotals  from '../../shared/components/POTotals';
import ConfirmMessageBox from 'AddEditView/ConfirmMessageBox';
import {ACTION_TYPE} from 'constants/App';
import './ClosePO.css';
import FormWrapper from 'components/FormWrapper';
import Shared from 'selectors/shared';
import * as constants from 'constants/App';
import { isCarWashVendor} from 'utils/HelperFunctions';
import DotInspection from '../screens/DotInspection';
import BitInspection from '../screens/BitInspection';
import FraInspection from '../screens/FraInspection';
import CraneInspection from '../screens/CraneInspection';
import ContactCustomerDirectlyForApprovalBanner from 'components/ContactCustomerDirectlyForApprovalBanner';
import { ThirdLevelSubhead } from 'shared/DesignSpecs/components/FontGuide';
import { event } from 'services/GoogleAnalytics';
import { useLocation, useParams } from 'react-router-dom';

const ClosePO = (props) => {
    const params = useParams();
    const location = useLocation();
    const closePOShowConfirmWindow = useRef(null);
    const wasCloseBlockedRef = useRef(false);

    useEffect(() => {
        // Load Data
        props.dispatch(actions.closeScreenPOLoaded(params.trackNumber));
        props.dispatch(actions.resetInvoiceDetails());
    }, [props.dispatch, params.trackNumber]);

    const RedirectUserToDashboardHandler = (e) => {
        e.preventDefault();
        if (isCarWashVendor(props.serviceClassification)) {
            props.dispatch({type: constants.NAVIGATE_TO, path: '/carWash'});
        }
        else {
            props.dispatch({type: constants.NAVIGATE_TO, path: '/'});
        }
    };

    const onClosePoHandler = () => {
        // Track successful PO close event
        event({
            action: 'close_po',
            category: 'PO',
            label: 'Close PO',
            value: params.trackNumber
        });
        props.dispatch(actions.closePOClicked({poNumber: params.trackNumber, claimId: location.state?.claimId}));
    };

    const updateOdometerWarningsHandler = (showWarning) => {
        props.dispatch(actions.showOdometerWarnings(showWarning));
    };

    const updateEngineHoursWarningsHandler = (showWarning) => {
        props.dispatch(actions.showEngineHoursWarnings(showWarning));
    };

    const lineItems = props.lineItems || Map();
    const vendor = props.vendor || Map();
    const hasClosePoData = vendor.size > 0 && props.vehicleDetails && props.vehicleDetails.size > 0;
    const nonMaintenanceLineItems = lineItems.valueSeq().filter(li => li.get('complaintCode') != 'MA99' && li.get('complaintCode') != 'DG99').toMap();
    const maintenanceLineItems = lineItems.valueSeq().filter(li => li.get('complaintCode') == 'MA99').toMap();
    const diagnosisLineItems = lineItems.valueSeq().filter(li => li.get('complaintCode') == 'DG99').toMap();
    const vendorCanClosePo = vendor.get('paymentType') == 'INTELLIPAY'
        || (vendor.get('paymentType') == 'STANDARD'
            && ((vendor.get('paymentMethod') == 'ACCOUNT' && vendor.get('bankAccountNumber') != null)
                || vendor.get('paymentMethod') == 'CHECK'));
    const isDiagnosisPo = nonMaintenanceLineItems.count() == 0 && maintenanceLineItems.count() == 0 && diagnosisLineItems.count() > 0;
    const isCloseBlocked = hasClosePoData && (!vendorCanClosePo || isDiagnosisPo) && !props.isWorkCompletionFeatureEnabled;

    useEffect(() => {
        if (isCloseBlocked && !wasCloseBlockedRef.current && closePOShowConfirmWindow.current) {
            closePOShowConfirmWindow.current.showModal();
        }

        wasCloseBlockedRef.current = isCloseBlocked;
    }, [isCloseBlocked]);

    if (props.isfetchingData || props.vehicleDetails == undefined) {
            return <Spinner />;
    }

        const messages = defineMessages({
            close_po_title: {
                id: 'page_title',
                description: `Close purchase order no.`,
                defaultMessage: `Close purchase order no.`
            },
            close_po_confirmation_title: {
                id: 'close_po_confirmation_title',
                description: `Close PO`,
                defaultMessage: `Close PO`
            },
            close_po_has_diagnosis_lines_only_message: {
                id: 'close_po_has_diagnosis_lines_only_message',
                description: 'PO’s cannot be closed for diagnosis only. Please correct line item(s) to indicate the repairs completed and resubmit or contact 1-866-274-1025 for assistance.',
                defaultMessage: 'PO’s cannot be closed for diagnosis only. Please correct line item(s) to indicate the repairs completed and resubmit or contact 1-866-274-1025 for assistance.'
            },
            close_po__non_intellipay_vendor: {
                id: 'close_po__non_intellipay_vendor',
                description: 'This PO cannot be processed online. Please submit this invoice through your corporate remit for payment.',
                defaultMessage: 'This PO cannot be processed online. Please submit this invoice through your corporate remit for payment.'
            },
            close_po_confirmation_ok: {
                id: 'close_po_confirmation_ok',
                description: 'OK',
                defaultMessage: 'OK'
            },
            close_po__accident_claim: {
                id: "close_po__accident_claim",
                description: "For claim {claimId}",
                defaultMessage: "For claim {claimId}",
            }
        });

        const showBankAccountRadioButton =
            !props.isWorkCompletionFeatureEnabled &&
            ((props.vendor.get('paymentType')=="STANDARD" && props.vendor.get('id').startsWith('0')) ||
            (props.vendor.get('paymentType')=="STANDARD" && !props.vendor.get('id').startsWith('0') && props.vendor.get('paymentMethod')=="CHECK") ||
            props.isWorkCompletionFeatureEnabled ?
            false: props.vendor.get('bankAccountNumber') != undefined && props.vendor.get('bankAccountNumber')!=''? true:false);

        const showInvoiceRadioButton = props.vendor.get('paymentType')=='STANDARD'  &&
        (props.vendor.get('paymentMethod')=='CHECK'|| props.vendor.get('paymentMethod')=='ACCOUNT')? true:false;
    
        const isInsuracePo = !props.closePOPurchaseOrderData? false : props.closePOPurchaseOrderData.get('isInsurancePo');
        const entityForAssistance = !props.closePOPurchaseOrderData? false : props.closePOPurchaseOrderData.get('entityForAssistance');

        return <div>            
            <FormWrapper key='closePoErrorMessage' id="close-po-generic-error" {...props} formErrors={props.errorMessage} />
            <div className="close_po__title">
                <Title caption={<FormattedMessage {...messages.close_po_title}/>}/>
                {params.trackNumber}
                {location.state?.claimId ?
                    <ThirdLevelSubhead>
                        <FormattedMessage {...messages.close_po__accident_claim} values={{ claimId: location.state.claimId }} />
                    </ThirdLevelSubhead>
                : null}
            </div>

            <FormWrapper key='closePurchaseOrderErrorMessage' id="" {...props} formErrors={props.closePurchaseOrderErrorMessage} />    
            {props.vehicleDetails.get('isHsbClientVehicle') && entityForAssistance == constants.ENTITY_FOR_ASSISTANCE.CUSTOMER && <ContactCustomerDirectlyForApprovalBanner />}
            <ClosePurchaseOrder invoiceDetails={props.invoiceDetails}
                                onClosePO={onClosePoHandler}
                                onChange={(poInvoiceDetails) => events.onChangeHandlerClosePO(props.dispatch, poInvoiceDetails)}
                                onEditPO={() => events.onEditPOHandler(props.dispatch, params.trackNumber)}
                                approvedAmountTotal={props.approvedAmountTotal}
                                pendingAmountTotal={props.pendingAmountTotal}
                                vendor={props.vendor}
                                validationDetails={props.validationDetails}
                                poCreatedDate={props.poCreatedDate}
                                taxAmount={props.invoiceDetails.get('taxAmount')}
                                lineItemsTax={props.lineItemsTax}
                                popOverDisplayShowInvoiceNo={props.popOverDisplayShowInvoiceNo}
                                popOverDisplayShowInvoiceDate={props.popOverDisplayShowInvoiceDate}
                                popOverDisplayShowInvoiceName={props.popOverDisplayShowInvoiceName}
                                userLocale={props.userLocale}
                                popOverDisplayShowRepairCompleteDate={props.popOverDisplayShowRepairCompleteDate}
                                popOverDisplayShowRepairStartDate={props.popOverDisplayShowRepairStartDate}
                                popOverDisplayShowOdometer = {props.popOverDisplayShowOdometer}
                                popOverDisplayShowEngineHours = {props.popOverDisplayShowEngineHours}
                                popOverDisplayShowPaymentCredit={props.popOverDisplayShowPaymentCredit}
                                popOverDisplayShowWorkComplete={props.popOverDisplayShowWorkComplete}
                                popOverDisplayShowStandard={props.popOverDisplayShowStandard}
                                popOverDisplayShowTax={props.popOverDisplayShowTax}
                                popOverDisplayShowTaxCanada={props.popOverDisplayShowTaxCanada}
                                popOverDisplayShowTaxExe={props.popOverDisplayShowTaxExe}
                                onTotalAmount={props.onTotalAmount}
                                onTaxAmount={props.onTaxAmount}
                                subTotal={props.subTotal}
                                taxTotal={props.taxTotal}
                                taxErrorMessage={props.taxErrorMessage}
                                vehicleDetails={props.vehicleDetails}
                                vehicleDetailsForOdometerWarnings = {props.vehicleDetailsForOdometerWarnings}
                                updateOdometerWarnings = {updateOdometerWarningsHandler}
                                updateEngineHoursWarnings = {updateEngineHoursWarningsHandler}
                                showOdometerWarning = {props.showOdometerWarning}
                                showEngineHoursWarning = {props.showEngineHoursWarning}
                                showBankAccountRadioButton={showBankAccountRadioButton}
                                showInvoiceRadioButton={showInvoiceRadioButton}
                                isClosingPO={props.isClosingPO}
                                selectedCurrency={props.selectedCurrency}
                                applicableTaxTypes={props.applicableTaxTypes}
                                allowWorkCompletion = {props.isWorkCompletionFeatureEnabled}
                                allowEditPO = {!(isCarWashVendor(props.serviceClassification) || isInsuracePo) }
                                popOverDisplayShowRefNumber={props.popOverDisplayShowRefNumber}
                                closePOVendorReferenceNo={props.closePOVendorReferenceNo}
                                uiTaxes={props.uiTaxes}
                                fieldValidationsData={props.fieldValidationsData}
                                selectedCountry={props.country}
            />
            
            <PurchaseOrderBasicDetails vehicleDetails={props.vehicleDetails}
                                       client={props.client}
                                       paymentStatus={props.paymentStatus}
                                       authorizedStatus={props.authorizedStatus}
                                       actionType={ACTION_TYPE.CLOSE}/>

            <ApprovedLineItems complaints={props.complaints}
                               nonMaintenanceNotes={props.nonMaintenanceNotes}
                               maintenanceNotesText={props.maintenanceNotesText}
                               lineItems={props.lineItems}
                               paymentStatus={props.paymentStatus}
                               authorizedStatus={props.authorizedStatus}
                               actionType={ACTION_TYPE.CLOSE}
                               selectedCurrency={props.selectedCurrency}
                               listOfComplaintsForWhichNoteIsRequired={props.listOfComplaintsForWhichNoteIsRequired}
            />

            <POTotals approvedAmountTotal={props.approvedAmountTotal}
                      pendingAmountTotal={props.pendingAmountTotal}
                      taxAmount={props.invoiceDetails.get('taxAmount')}
                      actionType={ACTION_TYPE.CLOSE}
                      paymentStatus={props.paymentStatus}
                      selectedCurrency={props.selectedCurrency}
                      authorizedStatus={props.authorizedStatus}/>
 
            { isCloseBlocked ?
                <ConfirmMessageBox ref={closePOShowConfirmWindow} showCancelButton={false}
                                    title={messages.close_po_confirmation_title}
                                    message={isDiagnosisPo ? messages.close_po_has_diagnosis_lines_only_message 
                                        : messages.close_po__non_intellipay_vendor}
                                    okButtonText={messages.close_po_confirmation_ok}
                                    cancelButtonText={messages.close_po_confirmation_ok}
                                    onOKClickEvent={RedirectUserToDashboardHandler}
                                    onCancelClickEvent={null}/>

            : undefined} 

            <DotInspection />
			<BitInspection />
			<FraInspection />
            <CraneInspection />
                        
        </div>;
}

//I moved the original selector into this function.  It was getting too "clunky".
//If you just needed 1 node from the Redux store, you don't need a reselect.
//Instead you can make a new property in the JSON object below and assign the value from state.
//If you need a derived value, create a new selector in a new file and call below.
function mapStateToProps(state, props) {
    return {
        nonMaintenanceNotes: Notes.getNonMaintenanceNotes(state, props),
        maintenanceNotesText: Notes.getMaintenanceNotesText(state, props),
        taxErrorMessage: state.appState.getIn(['uiData', 'close', 'taxErrorMessage']),        
        //example:
        //oneToOnePropToState: state.appState.getIn(['uiData', 'area', 'oneToOnePropToState']),
        //newDerivedProp: newDerivedSelector(state, props),
        ...ClosePOSelector(state, props),
         ...Shared(state, props),
         errorMessage: state.appState.getIn(['uiData', 'shared', 'errorMessage']),
        isClosingPO: state.appState.getIn(['uiData', 'close', 'isClosingPO']),
        selectedCurrency:state.appState.getIn(['uiData', 'shared','selectedCurrency']),
        serviceClassification: state.appState.getIn(['serverData', 'shared', 'serviceClassification']),
        closePOPurchaseOrderData: state.appState.getIn(['serverData', 'close', 'purchaseOrder']),
        closePOVendorReferenceNo: state.appState.getIn(['serverData', 'close', 'vendorReferenceNo']),
        isDotInpsectionRequired: state.appState.getIn(['serverData', 'close', 'isDotInspectionRequired']),
		fieldValidationsData: state.appState.getIn(['uiData', 'shared', 'fieldValidations']),
        isWorkCompletionFeatureEnabled: state.appState.getIn(['uiData', 'shared', 'features','workCompletion']),
        country: state.appState.getIn(['uiData', 'shared','selectedCountry']),
    };
}


export default connect(mapStateToProps)(ClosePO);